export enum POP_DIRECTION {
    TOP = 'top',
    BOTTOM = 'bottom',
    LEFT = 'left',
    RIGHT = 'right',
    OPPOSITE = 'opposite',
    OVERLAY = 'overlay'
}
